import { createSlice } from "@reduxjs/toolkit";
import { clientDirectoryReducer } from "./reducer";
import { initialState } from "./initialState";
import {
  addClientDirectoryAction,
  addLeadCommentsAction,
  changeClientStatusAction,
  clientAadharUniqueCheckAction,
  clientPanUniqueCheckAction,
  getClientDirectoryLeadListAction,
  getClientDirectoryLeadStageCountAction,
  getClientDirectoryListAction,
  getLeadCommentsDetailsAction,
  getSingleClientDirectoryAction,
  getSingleClientDirectoryLeadDetailsAction,
  leadHistoryAction,
  leadSentEmailAction,
  leadClientSentEmailHistoryAction,
  updateClientDirectoryAction,
  updateClientDirectoryLeadDetailsAction,
  clientSentEmailAction,
  updateClientMeetUpChecklistAction,
  getClientMeetUpChecklistAction,
  getSingleClientMeetUpChecklistAction,
  addLeadRecordingAction,
  getLeadRecordingDetailsAction,
  getCityListAction,
  updateLeadStatusAction,
  getStageListAction,
  updateLeadStageAction,
  getClientDirectorySortByThresholdLeadListAction,
  getClientDirectoryLeadStageSortByStageCountAction,
} from "./action";
import { ClientDirectoryType } from "./clientDirectoryType";

export const clientDirectorySlice = createSlice({
  name: "clientDirectory",
  initialState,
  reducers: clientDirectoryReducer,
  extraReducers: {
    [getClientDirectoryListAction.pending.toString()]: (
      state: ClientDirectoryType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getClientDirectoryListAction.fulfilled.toString()]: (
      state: ClientDirectoryType,
      { payload }
    ) => {
      const { data } = payload;
      const { success, message, status_code, result } = data;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          statusCode: status_code,
          success,
        };
      }
      return {
        ...state,
        fetching: false,
        success,
        clientDirectoryList: result?.data,
        totalCount: result?.total_count,
      };
    },
    [getClientDirectoryListAction.rejected.toString()]: (
      state: ClientDirectoryType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error.message,
    }),
    [getSingleClientDirectoryAction.pending.toString()]: (
      state: ClientDirectoryType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getSingleClientDirectoryAction.fulfilled.toString()]: (
      state: ClientDirectoryType,
      { payload }
    ) => {
      const { data } = payload;
      const { success, message, status_code, result } = data;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          statusCode: status_code,
          success,
        };
      }
      return {
        ...state,
        fetching: false,
        // success,
        singleClientDirectory: result,
      };
    },
    [getSingleClientDirectoryAction.rejected.toString()]: (
      state: ClientDirectoryType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error.message,
    }),
    [updateClientDirectoryAction.pending.toString()]: (
      state: ClientDirectoryType
    ) => ({
      ...state,
      fetching: true,
    }),
    [updateClientDirectoryAction.fulfilled.toString()]: (
      state: ClientDirectoryType,
      { payload }
    ) => {
      const { success, message, status_code } = payload?.data;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          statusCode: status_code,
          success,
        };
      }
      return {
        ...state,
        fetching: false,
        success,
        statusCode: status_code,
      };
    },
    [updateClientDirectoryAction.rejected.toString()]: (
      state: ClientDirectoryType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error.message,
    }),
    [changeClientStatusAction.pending.toString()]: (
      state: ClientDirectoryType
    ) => ({
      ...state,
      fetching: true,
    }),
    [changeClientStatusAction.fulfilled.toString()]: (
      state: ClientDirectoryType,
      { payload }
    ) => {
      const { success, message, status_code } = payload?.data;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          statusCode: status_code,
          clientStatusSuccess: success,
        };
      }
      return {
        ...state,
        fetching: false,
        clientStatusSuccess: success,
        statusCode: status_code,
      };
    },
    [changeClientStatusAction.rejected.toString()]: (
      state: ClientDirectoryType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      clientStatusSuccess: 0,
      error: error.message,
    }),
    // 
    [updateLeadStatusAction.pending.toString()]: (
      state: ClientDirectoryType
    ) => ({
      ...state
    }),
    [updateLeadStatusAction.fulfilled.toString()]: (
      state: ClientDirectoryType,
      { payload }
    ) => {
      const { success, message, status_code } = payload;
      if (success === 0) {
        return {
          ...state,
          error: message,
          statusCode: status_code,
          success: success,
        };
      }
      return {
        ...state,
        success: success,
        statusCode: status_code,
        message
      };
    },
    [updateLeadStatusAction.rejected.toString()]: (
      state: ClientDirectoryType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error.message,
    }),
    [updateLeadStageAction.pending.toString()]: (
      state: ClientDirectoryType
    ) => ({
      ...state,
      fetching:true
    }),
    [updateLeadStageAction.fulfilled.toString()]: (
      state: ClientDirectoryType,
      { payload }
    ) => {
      const { success, message, status_code } = payload;
      if (success === 0) {
        return {
          ...state,
          error: message,
          statusCode: status_code,
          success,
          fetching:false
        };
      }
      return {
        ...state,
        success: success,
        statusCode: status_code,
        fetching:false,
        message
      };
    },
    [updateLeadStageAction.rejected.toString()]: (
      state: ClientDirectoryType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error.message,
    }),
    [getStageListAction.pending.toString()]: (
      state: ClientDirectoryType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getStageListAction.fulfilled.toString()]: (
      state: ClientDirectoryType,
      { payload }
    ) => {
      // const { data } = payload;
      const { success, message, status_code, result, total_count } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          statusCode: status_code,
          success,
        };
      }
      return {
        ...state,
        fetching: false,
        leadStageList: result,
        leadStageTotal: total_count,
      };
    },
    [getStageListAction.rejected.toString()]: (
      state: ClientDirectoryType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error.message,
    }),
    [addClientDirectoryAction.pending.toString()]: (
      state: ClientDirectoryType
    ) => ({
      ...state,
      fetching: true,
    }),
    [addClientDirectoryAction.fulfilled.toString()]: (
      state: ClientDirectoryType,
      { payload }
    ) => {
      const { success, message, status_code } = payload?.data;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          statusCode: status_code,
          success,
        };
      }
      return {
        ...state,
        fetching: false,
        success,
        statusCode: status_code,
      };
    },
    [addClientDirectoryAction.rejected.toString()]: (
      state: ClientDirectoryType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error.message,
    }),
    [clientAadharUniqueCheckAction.pending.toString()]: (
      state: ClientDirectoryType
    ) => ({
      ...state,
      clientAadharUniqueCheckFetching: true,
    }),
    [clientAadharUniqueCheckAction.fulfilled.toString()]: (
      state: ClientDirectoryType,
      { payload }
    ) => {
      const { success, message, status_code } = payload;
      if (success === 0) {
        return {
          ...state,
          clientAadharUniqueCheckFetching: false,
          clientAadharUniqueCheckError: message,
          statusCode: status_code,
          clientAadharUniqueCheckSuccess: success,
        };
      }
      return {
        ...state,
        clientAadharUniqueCheckMessage: message,
        clientAadharUniqueCheckFetching: false,
        clientAadharUniqueCheckSuccess: success,
        statusCode: status_code,
      };
    },
    [clientAadharUniqueCheckAction.rejected.toString()]: (
      state: ClientDirectoryType,
      { error }
    ) => ({
      ...state,
      clientAadharUniqueCheckFetching: false,
      clientAadharUniqueCheckSuccess: 0,
      clientAadharUniqueCheckError: error.message,
    }),
    [clientPanUniqueCheckAction.pending.toString()]: (
      state: ClientDirectoryType
    ) => ({
      ...state,
      clientPanUniqueCheckFetching: true,
    }),
    [clientPanUniqueCheckAction.fulfilled.toString()]: (
      state: ClientDirectoryType,
      { payload }
    ) => {
      const { success, message, status_code } = payload;
      if (success === 0) {
        return {
          ...state,
          clientPanUniqueCheckFetching: false,
          clientPanUniqueCheckError: message,
          statusCode: status_code,
          clientPanUniqueCheckSuccess: success,
        };
      }
      return {
        ...state,
        clientPanUniqueCheckFetching: false,
        clientPanUniqueCheckSuccess: success,
        clientPanUniqueCheckMessage: message,
        statusCode: status_code,
      };
    },
    [clientPanUniqueCheckAction.rejected.toString()]: (
      state: ClientDirectoryType,
      { error }
    ) => ({
      ...state,
      clientPanUniqueCheckFetching: false,
      clientPanUniqueCheckSuccess: 0,
      clientPanUniqueCheckError: error.message,
    }),
    // lead
    [getClientDirectoryLeadListAction.pending.toString()]: (
      state: ClientDirectoryType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getClientDirectoryLeadListAction.fulfilled.toString()]: (
      state: ClientDirectoryType,
      { payload }
    ) => {
      const { data } = payload;
      const { success, message, status_code, result, total_count } = data;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          statusCode: status_code,
          success,
        };
      }
      return {
        ...state,
        fetching: false,
        success,
        leadDirectoryList: result,
        leadDirectoryTotal: total_count,
      };
    },
    [getClientDirectoryLeadListAction.rejected.toString()]: (
      state: ClientDirectoryType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error.message,
    }),
    [getClientDirectorySortByThresholdLeadListAction.pending.toString()]: (
      state: ClientDirectoryType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getClientDirectorySortByThresholdLeadListAction.fulfilled.toString()]: (
      state: ClientDirectoryType,
      { payload }
    ) => {
      const { data } = payload;
      const { success, message, status_code, result, total_count } = data;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          statusCode: status_code,
          success,
        };
      }
      return {
        ...state,
        fetching: false,
        success,
        leadDirectoryList: result,
        leadDirectoryTotal: total_count,
      };
    },
    [getClientDirectorySortByThresholdLeadListAction.rejected.toString()]: (
      state: ClientDirectoryType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error.message,
    }),
    [getClientDirectoryLeadStageCountAction.pending.toString()]: (
      state: ClientDirectoryType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getClientDirectoryLeadStageCountAction.fulfilled.toString()]: (
      state: ClientDirectoryType,
      { payload }
    ) => {
      const { data } = payload;
      const { success, message, status_code, result, total_count } = data;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          statusCode: status_code,
          success,
        };
      }
      return {
        ...state,
        fetching: false,
        success,
        leadStageCount: result,
      };
    },
    [getClientDirectoryLeadStageCountAction.rejected.toString()]: (
      state: ClientDirectoryType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error.message,
    }),
    [getClientDirectoryLeadStageSortByStageCountAction.pending.toString()]: (
      state: ClientDirectoryType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getClientDirectoryLeadStageSortByStageCountAction.fulfilled.toString()]: (
      state: ClientDirectoryType,
      { payload }
    ) => {
      const { data } = payload;
      const { success, message, status_code, result, total_count } = data;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          statusCode: status_code,
          success,
        };
      }
      return {
        ...state,
        fetching: false,
        success,
        leadStageCount: result,
      };
    },
    [getClientDirectoryLeadStageSortByStageCountAction.rejected.toString()]: (
      state: ClientDirectoryType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error.message,
    }),
    
    [getSingleClientDirectoryLeadDetailsAction.pending.toString()]: (
      state: ClientDirectoryType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getSingleClientDirectoryLeadDetailsAction.fulfilled.toString()]: (
      state: ClientDirectoryType,
      { payload }
    ) => {
      const { data } = payload;
      const { success, message, status_code, result } = data;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          statusCode: status_code,
          success,
        };
      }

      return {
        ...state,
        fetching: false,
        // success,
        singleClientleadDirectoryDetails: result,
      };
    },
    [getSingleClientDirectoryLeadDetailsAction.rejected.toString()]: (
      state: ClientDirectoryType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error.message,
    }),
    [updateClientDirectoryLeadDetailsAction.pending.toString()]: (
      state: ClientDirectoryType
    ) => ({
      ...state,
      fetching: true,
    }),
    [updateClientDirectoryLeadDetailsAction.fulfilled.toString()]: (
      state: ClientDirectoryType,
      { payload }
    ) => {
      const { data } = payload;
      const { success, message, status_code } = data;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          statusCode: status_code,
          success,
        };
      }
      return {
        ...state,
        fetching: false,
        success,
      };
    },
    [updateClientDirectoryLeadDetailsAction.rejected.toString()]: (
      state: ClientDirectoryType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error.message,
    }),

    //  comment
    [getLeadCommentsDetailsAction.pending.toString()]: (
      state: ClientDirectoryType
    ) => ({
      ...state,
      leadDirectoryCommentsFetching: true,
    }),
    [getLeadCommentsDetailsAction.fulfilled.toString()]: (
      state: ClientDirectoryType,
      { payload }
    ) => {
      //    const {data}=payload;
      const { success, message, status_code, result } = payload;
      if (success === 0) {
        return {
          ...state,
          leadDirectoryCommentsFetching: false,
          error: message,
          statusCode: status_code,
          success: success,
        };
      }
      return {
        ...state,
        leadDirectoryCommentsFetching: false,
        // success:success,
        leadDirectoryCommentsList: result,
        statusCode: status_code,
        // leadDirectoryTotal:total_count
      };
    },
    [getLeadCommentsDetailsAction.rejected.toString()]: (
      state: ClientDirectoryType,
      { error }
    ) => ({
      ...state,
      leadDirectoryCommentsFetching: false,
      success: 0,
      error: error.message,
    }),
    // city
    [getCityListAction.pending.toString()]: (
      state: ClientDirectoryType
    ) => ({
      ...state,
      cityFetching: true,
    }),
    [getCityListAction.fulfilled.toString()]: (
      state: ClientDirectoryType,
      { payload }
    ) => {
      //    const {data}=payload;
      const { success, message, status_code, result } = payload;
      if (success === 0) {
        return {
          ...state,
          cityFetching: false,
          error: message,
          statusCode: status_code,
          success: success,
        };
      }
      return {
        ...state,
        cityFetching: false,
        // success:success,
        uniqueCityList: result?.data,
        uniqueCityCount: result?.total_count,
        statusCode: status_code,
        // leadDirectoryTotal:total_count
      };
    },
    [getCityListAction.rejected.toString()]: (
      state: ClientDirectoryType,
      { error }
    ) => ({
      ...state,
      cityFetching: false,
      success: 0,
      error: error.message,
    }),
    
    [getLeadRecordingDetailsAction.pending.toString()]: (
      state: ClientDirectoryType
    ) => ({
      ...state,
      leadDirectoryRecordingsFetching: true,
    }),
    [getLeadRecordingDetailsAction.fulfilled.toString()]: (
      state: ClientDirectoryType,
      { payload }
    ) => {
      //    const {data}=payload;
      const { success, message, status_code, result } = payload;
      if (success === 0) {
        return {
          ...state,
          leadDirectoryRecordingsFetching: false,
          error: message,
          statusCode: status_code,
          success: success,
        };
      }
      return {
        ...state,
        leadDirectoryRecordingsFetching: false,
        leadDirectoryRecordingsList: result,
        statusCode: status_code,
      };
    },
    [getLeadRecordingDetailsAction.rejected.toString()]: (
      state: ClientDirectoryType,
      { error }
    ) => ({
      ...state,
      leadDirectoryRecordingsFetching: false,
      success: 0,
      error: error.message,
    }),
    //  add comment
    [addLeadCommentsAction.pending.toString()]: (
      state: ClientDirectoryType
    ) => ({
      ...state,
      leadDirectoryCommentsFetching: true,
    }),
    [addLeadCommentsAction.fulfilled.toString()]: (
      state: ClientDirectoryType,
      { payload }
    ) => {
      const { success, message, status_code, result } = payload;
      if (success === 0) {
        return {
          ...state,
          leadDirectoryCommentsFetching: false,
          error: message,
          statusCode: status_code,
          leadDirectoryCommentsSuccess: success,
        };
      }
      return {
        ...state,
        leadDirectoryCommentsFetching: false,
        leadDirectoryCommentsSuccess: success,
        statusCode: status_code,
        responsiblePeople: result,
      };
    },
    [addLeadCommentsAction.rejected.toString()]: (
      state: ClientDirectoryType,
      { error }
    ) => ({
      ...state,
      leadDirectoryCommentsFetching: false,
      leadDirectoryCommentsSuccess: 0,
      error: error.message,
    }),

    [addLeadRecordingAction.pending.toString()]: (
      state: ClientDirectoryType
    ) => ({
      ...state,
      leadDirectoryRecordingsFetching: true,
    }),
    [addLeadRecordingAction.fulfilled.toString()]: (
      state: ClientDirectoryType,
      { payload }
    ) => {
      const { success, message, status_code, result } = payload;
      if (success === 0) {
        return {
          ...state,
          leadDirectoryRecordingsFetching: false,
          error: message,
          statusCode: status_code,
          leadDirectoryRecordingsSuccess: success,
        };
      }
      return {
        ...state,
        leadDirectoryRecordingsFetching: false,
        leadDirectoryRecordingsSuccess: success,
        statusCode: status_code,
        responsiblePeople: result,
      };
    },
    [addLeadRecordingAction.rejected.toString()]: (
      state: ClientDirectoryType,
      { error }
    ) => ({
      ...state,
      leadDirectoryRecordingsFetching: false,
      leadDirectoryRecordingsSuccess: 0,
      error: error.message,
    }),

    //

    [leadSentEmailAction.pending.toString()]: (state: ClientDirectoryType) => ({
      ...state,
      emailFetching: true,
    }),
    [leadSentEmailAction.fulfilled.toString()]: (
      state: ClientDirectoryType,
      { payload }
    ) => {
      const { success, message, status_code } = payload;
      if (success === 0) {
        return {
          ...state,
          emailFetching: false,
          error: message,
          statusCode: status_code,
          success: 0,
        };
      }
      return {
        ...state,
        message,
        statusCode: status_code,
        success,
        emailFetching: false,
      };
    },
    [leadSentEmailAction.rejected.toString()]: (
      state: ClientDirectoryType,
      { error }
    ) => ({
      ...state,
      emailFetching: false,
      success: 0,
      error: error.message,
    }),

    [clientSentEmailAction.pending.toString()]: (
      state: ClientDirectoryType
    ) => ({
      ...state,
      emailFetching: true,
    }),
    [clientSentEmailAction.fulfilled.toString()]: (
      state: ClientDirectoryType,
      { payload }
    ) => {
      const { success, message, status_code } = payload;
      if (success === 0) {
        return {
          ...state,
          emailFetching: false,
          error: message,
          statusCode: status_code,
          success: 0,
        };
      }
      return {
        ...state,
        message,
        statusCode: status_code,
        success,
        emailFetching: false,
      };
    },
    [clientSentEmailAction.rejected.toString()]: (
      state: ClientDirectoryType,
      { error }
    ) => ({
      ...state,
      emailFetching: false,
      success: 0,
      error: error.message,
    }),
    ////
    [leadHistoryAction.pending.toString()]: (state: ClientDirectoryType) => ({
      ...state,
      leadFetching: true,
    }),
    [leadHistoryAction.fulfilled.toString()]: (
      state: ClientDirectoryType,
      { payload }
    ) => {
      const { success, message, status_code, result } = payload;
      if (success === 0) {
        return {
          ...state,
          leadFetching: false,
          error: message,
          statusCode: status_code,
          success: success,
        };
      }
      return {
        ...state,
        leadFetching: false,
        leadHistory: result,
        statusCode: status_code,
      };
    },
    [leadHistoryAction.rejected.toString()]: (
      state: ClientDirectoryType,
      { error }
    ) => ({
      ...state,
      leadFetching: false,
      success: 0,
      error: error.message,
    }),
    [leadClientSentEmailHistoryAction.pending.toString()]: (
      state: ClientDirectoryType
    ) => ({
      ...state,
      emailFetching: true,
    }),
    [leadClientSentEmailHistoryAction.fulfilled.toString()]: (
      state: ClientDirectoryType,
      { payload }
    ) => {
      const { success, message, status_code, result } = payload;
      if (success === 0) {
        return {
          ...state,
          emailFetching: false,
          error: message,
          statusCode: status_code,
          success: success,
        };
      }
      return {
        ...state,
        emailFetching: false,
        leadClientEmailHistory: result,
        statusCode: status_code,
      };
    },
    [leadClientSentEmailHistoryAction.rejected.toString()]: (
      state: ClientDirectoryType,
      { error }
    ) => ({
      ...state,
      emailFetching: false,
      success: 0,
      error: error.message,
    }),
    [updateClientDirectoryLeadDetailsAction.rejected.toString()]: (
      state: ClientDirectoryType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error.message,
    }),
    [updateClientMeetUpChecklistAction.pending.toString()]: (
      state: ClientDirectoryType
    ) => ({
      ...state,
      fetching: true,
    }),
    [updateClientMeetUpChecklistAction.fulfilled.toString()]: (
      state: ClientDirectoryType,
      { payload }
    ) => {
      const { data } = payload;
      const { success, message, status_code } = data;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          statusCode: status_code,
          success,
        };
      }
      return {
        ...state,
        fetching: false,
        success,
        message
      };
    },
    [updateClientMeetUpChecklistAction.rejected.toString()]: (
      state: ClientDirectoryType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error.message,
    }),
    [getClientMeetUpChecklistAction.pending.toString()]: (
      state: ClientDirectoryType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getClientMeetUpChecklistAction.fulfilled.toString()]: (
      state: ClientDirectoryType,
      { payload }
    ) => {
      const { success, message, status_code, result, total_count } = payload;
      if (success === 0) {
        return {
          ...state,
          client: false,
          error: message,
          statusCode: status_code,
          success: success,
        };
      }
      return {
        ...state,
        fetching: false,
        clientMeetUpChecklistData: result,
        statusCode: status_code,
        totalCount: total_count,
      };
    },
    [getClientMeetUpChecklistAction.rejected.toString()]: (
      state: ClientDirectoryType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error.message,
    }),
    [getSingleClientMeetUpChecklistAction.pending.toString()]: (
      state: ClientDirectoryType
    ) => ({
      ...state,
      fetching: true,
    }),
    [getSingleClientMeetUpChecklistAction.fulfilled.toString()]: (
      state: ClientDirectoryType,
      { payload }
    ) => {
      const { success, message, status_code, result } = payload;
      if (success === 0) {
        return {
          ...state,
          client: false,
          error: message,
          statusCode: status_code,
          success: success,
        };
      }
      return {
        ...state,
        fetching: false,
        singleClientMeetUpChecklistData: result,
        statusCode: status_code,
      };
    },
    [getSingleClientMeetUpChecklistAction.rejected.toString()]: (
      state: ClientDirectoryType,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error.message,
    }),
  },
});
export const {
  resetClientDirectoryError,
  resetClientDirectoryMessage,
  resetClientDirectoryStatusCode,
  resetClientDirectorySuccess,
  resetClientDirectoryList,
  resetClientDirectoryFetching,
  resetSingleClientDirectory,
  resetClientDirectoryTotalCount,
  resetClientStatusSuccess,
  resetClientAadharUniqueCheckSuccess,
  resetClientAadharUniqueCheckError,
  resetClientAadharUniqueCheckMessage,
  resetClientPanUniqueCheckSuccess,
  resetClientPanUniqueCheckError,
  resetClientPanUniqueCheckMessage,
  resetLeadDirectoryTotal,
  resetLeadDirectoryList,
  resetSingleClientLeadDirectoryDetails,
  resetLeadModuleCommentsSuccess,
  resetLeadModuleCommentsListing,
  resetLeadDirectoryCommentsFetching,
  resetLeadHistory,
  resetLeadStageCount,
  resetLeadClientEmailHistory,
  resetLeadEmailFetching,
  setPersistLeadDirectory,
  resetLeadModuleRecordingsSuccess,
  resetLeadModuleRecordingsListing,
  resetLeadDirectoryRecordingsFetching,
  resetClientMeetUpChecklistData,
  resetSingleClientMeetUpCheklistData,
  resetUniqueCityList,
  resetUniqueCityCount,
  resetCityFetching,
  resetLeadStageList,
  resetLeadStageTotal
} = clientDirectorySlice.actions;
